import {
  ComponentLoggingEventParams,
  SDUIComponentRenderBehaviour,
} from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import type { IBannerComponent } from "@faire/web-api--source/indigofair/data/IBannerComponent";

import { SDUIImageBannerV2Renderer } from "./ImageBannerV2/SDUIImageBannerV2Renderer";

type SDUIInlineBannerProps = {
  bannerComponent: IBannerComponent;
  loggingData: ComponentLoggingEventParams;
  renderBehaviour?: SDUIComponentRenderBehaviour;
};

/**
 * The inline banner is a variation of the image banner that has no outer spacing.
 * See
 */
export const SDUIInlineBannerRenderer = (props: SDUIInlineBannerProps) => {
  return <SDUIImageBannerV2Renderer {...props} inline />;
};
